<template>
  <div>
    <a @click="fetchOnlineUserList">刷新</a>
    <monitor_customer :news="all_online_list" ></monitor_customer>
  </div>
</template>

<script>
import monitor_customer from "../components/monitor_list/monitor_customer.vue";

import {queryOnlineUserList} from "../graphql/api";
import { mapState,mapMutations } from "vuex";
export default {
  name: "monitor_screen",
  components:{
    monitor_customer
  },
  computed:{
    ...mapState(["userEventLog","userAllEventLog"])
  },

  mounted() {
    this.fetchOnlineUserList();
  },
  data(){
    return{
      all_online_list:[]
    }
  },
  methods: {
    ...mapMutations(["saveUserEventLog","saveUserAllEventLog"]),
    fetchOnlineUserList(){
      console.log("fetchOnlineUserList");
      let that = this;
      queryOnlineUserList().then((res)=>{
        console.log(res.data.findAllOnlineUser);

        that.all_online_list = res.data.findAllOnlineUser

        that.all_online_list.sort((a,b)=>{
          if(a.customerAccount) return 1;
          else if(b.customerAccount) return -1;
          else if((a.orderId == null) && (b.orderId == null)) {

            if((a.posId == null) && (b.posId == null)){
              return 0;
            }else{
              if(a.posId != null) return -1;
              else return 1;
            }

          }else{
            if(a.orderId != null) return -1;
            else return 1;
          };
        })

      })
    },
  }
}
</script>

<style src="../css/common.css" scoped>

</style>
<style src="../css/monitor_screen.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor_screen.vue